import React from 'react';
import { Icons } from '~/components';
import { resolveLinkColor } from '~/modules/Helper/contrast.helper';
import { VisualizarButton } from './style';

/**
 * Botão 32x32 para abrir a grid vinculada ao gráfico (home).
 */
function VisualizarGridButton({ to, corFonte }) {
  if (!to) return null;

  return (
    <VisualizarButton
      to={to}
      $color={resolveLinkColor(corFonte)}
      aria-label="Visualizar detalhes"
    >
      <Icons.EyeOutlined aria-hidden />
    </VisualizarButton>
  );
}

export default VisualizarGridButton;
